import { render } from "./ReadyComponent.vue?vue&type=template&id=5487d6b6&scoped=true"
import script from "./ReadyComponent.vue?vue&type=script&lang=js"
export * from "./ReadyComponent.vue?vue&type=script&lang=js"

import "./ReadyComponent.vue?vue&type=style&index=0&id=5487d6b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5487d6b6"]])

export default __exports__